import React, { forwardRef, memo } from 'react';
import CONFIG from '../../config';
import { FlexedFooter, Wrapper } from './styled';
import { About } from './About';
import { ContactUs } from './ContactUs';
import { Copyright } from './Copyright';
import { Locations } from './Locations';
import { useClient } from '../../hooks/useClient';

interface FooterProps {
  isTabBarExist?: boolean;
  isBackgroundBanner?: boolean;
  isShowLocations?: boolean;
}

const FooterComponent = forwardRef<HTMLElement, FooterProps>(
  (
    {
      isTabBarExist = false,
      isBackgroundBanner = false,
      isShowLocations = false
    },
    ref
  ) => {
    const isClient = useClient();

    const {
      contacts: {
        instagramLink,
        facebookLink,
        turboAppStoreLink,
        turboPlayMarketLink,
        tel_additional: telAdditional,
        tel_additional_url: telAdditionalUrl,
        email
      },
      currentYear
    } = CONFIG;

    return (
      <FlexedFooter
        ref={ref}
        $bottomSpace={isClient && isTabBarExist}
        $isBackgroundBanner={isClient && isBackgroundBanner}
        data-cy="footer"
        id="footer"
      >
        <Wrapper>
          <ContactUs
            {...{
              turboAppStoreLink,
              turboPlayMarketLink,
              telAdditional,
              telAdditionalUrl,
              email
            }}
          />
          {isShowLocations && <Locations />}
          <About />
          <Copyright {...{ currentYear, instagramLink, facebookLink }} />
        </Wrapper>
      </FlexedFooter>
    );
  }
);

FooterComponent.displayName = 'Footer';

export const Footer = memo(FooterComponent);
